import { UIHeading4, UIText1, ArticleParagraph2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IAgentCommentProps {
  comment?: string;
  onEditComment(): void;
}

export const Comment = ({ comment, onEditComment }: IAgentCommentProps) => {
  if (!comment) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <div className={styles['comment']}>
          <UIHeading4>Ваша заметка:</UIHeading4>
          <UIText1>{comment}</UIText1>
        </div>
      </div>
      <div className={styles['edit']} onClick={onEditComment}>
        <ArticleParagraph2 color="primary_100">Редактировать</ArticleParagraph2>
      </div>
    </div>
  );
};
